import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Card, CardBody, CardTitle, Button, Table } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCartPlus, faImage } from '@fortawesome/free-solid-svg-icons';
library.add(faCartPlus);
library.add(faImage)

class MapInfoBox extends Component {

    handleAddToCardtButton = (e)=>{
        e.preventDefault();
        this.props.addToCart(this.props.cartItems, this.props.set_marker_data);
    }

    render() {

        const { media_owner, latitude, longitude, city, state, media_type, lighting, locality, vendor, brand, site_code, site_map,sec_classifications } = this.props.infoBoxData;

        let image_url = "#";

        if(site_map){
            image_url = site_map
        }

        return <Container style={{width: '500px' , height: '250px'}}>
            <Card>
                <CardBody className="">
                    <CardTitle>Site Details { site_code }</CardTitle>
                    <Button className="m-1" size="sm" href={image_url} target="_blank"><FontAwesomeIcon icon="image"/></Button>
                    <Table className="mt-1" bordered striped>
                        <tbody>
                            <tr>
                                <th>Latitude</th>
                                <td>{latitude ?  latitude : "Not Available"}</td>
                                <th>Longitude</th>
                                <td>{longitude ?  longitude : "Not Available"}</td>
                            </tr>
                            <tr>
                                <th>City</th>
                                <td>{city ?  city : "Not Available"}</td>
                                <th>State</th>
                                <td>{state ?  state : "Not Available"}</td>
                            </tr>
                            <tr>
                                <th>Media Type</th>
                                <td>{media_type ?  media_type : "Not Available"}</td>
                                <th>Lighting</th>
                                <td>{lighting ?  lighting : "Not Available"}</td>
                            </tr>
                            <tr>
                                <th>Locality</th>
                                <td>{locality ?  locality : "Not Available"}</td>
                                <th>Vendor</th>
                                <td>{vendor ?  vendor : "Not Available"}</td>
                            </tr>
                            <tr>
                                <th>Brand</th>
                                <td>{brand ?  brand : "Not Available"}</td>
                                <th>Media Owner</th>
                                <td>{media_owner ?  media_owner : "Not Available"}</td>
                            </tr>
                            <tr>
                                <th>SEC</th>
                                <td>{sec_classifications ?  sec_classifications.toString() : "Not Available"}</td>
                                <th>Media Owner</th>
                                <td>{media_owner ?  media_owner : "Not Available"}</td>
                            </tr>
                        </tbody>
                    </Table>
                </CardBody>
            </Card>            
        </Container>
    }
}

const mapStateToProps = (state)=>{
    return {
        
    }
}

export default connect(mapStateToProps, { })(MapInfoBox);


// WEBPACK FOOTER //
// ./src/v3/components/campaign/mapInfoBox.js